import { makeObservable, action, observable } from "mobx";
import ApiService from "../services/ApiService.mjs";
import { Loadable } from "./models/Loadable.mjs";
class CardStore {
  constructor(apiService, paymentStore, cardManagerStore) {
    this.apiService = apiService;
    this.paymentStore = paymentStore;
    this.cardManagerStore = cardManagerStore;
    makeObservable(this, {
      startPaymentLoadable: observable,
      paymentStatusInterval: observable,
      startPaymentErrorMessage: observable,
      adyenPaymentMethodInputs: observable,
      reloadAdyenPaymentMethodInputs: observable,
      paymentRedirect: observable,
      startPaymentAndSetInterval: action,
      loadAdyenPaymentMethodInputs: action,
      initializeStartPaymentLoadable: action,
      setReloadAdyenPaymentMethodInputs: action,
      deleteSavedCard: action,
      trySetInterval: action,
      setPaymentHasError: action,
      clearInterval: action,
      getPaymentStatus: action.bound
    });
  }
  static INTERVAL_MS = 2e3;
  startPaymentLoadable;
  paymentStatusInterval;
  startPaymentErrorMessage = "";
  adyenPaymentMethodInputs;
  paymentRedirect;
  reloadAdyenPaymentMethodInputs = false;
  async startPaymentAndSetInterval(startPaymentRequest, actions) {
    try {
      this.cardManagerStore.resetResultNotice();
      this.paymentStore.setPaymentStatus("IN_PROGRESS");
      const startPaymentPromise = this.apiService.startCardPayment(startPaymentRequest);
      this.startPaymentLoadable = Loadable.toLoadable(startPaymentPromise);
      await startPaymentPromise;
      actions.resolve({ resultCode: "Pending" });
      this.trySetInterval();
    } catch (e) {
      actions.reject(e);
      this.setPaymentHasError("payment.card.errors.error-while-starting-payment");
    }
  }
  async loadAdyenPaymentMethodInputs(shopperReference, source) {
    try {
      const resources = this.apiService.getAdyenPaymentMethodInputs(shopperReference, source);
      this.adyenPaymentMethodInputs = Loadable.toLoadable(resources);
      await resources;
    } catch (e) {
      this.setPaymentHasError("payment.card.errors.error-while-starting-payment");
    }
  }
  initializeStartPaymentLoadable(cardTransactionReference) {
    const loadable = new Loadable();
    loadable.setSuccess({ transactionReference: cardTransactionReference });
    this.startPaymentLoadable = loadable;
    this.trySetInterval();
  }
  async deleteSavedCard(shopperReference, cardDetailsReference) {
    return this.apiService.deleteSavedCard(shopperReference, cardDetailsReference);
  }
  trySetInterval() {
    if (this.paymentReady && !this.paymentStatusInterval) {
      this.paymentStatusInterval = setInterval(() => this.getPaymentStatus(), CardStore.INTERVAL_MS);
    }
  }
  setPaymentHasError(errorMessage) {
    this.startPaymentErrorMessage = errorMessage;
  }
  clearInterval() {
    if (this.paymentStatusInterval) {
      clearInterval(this.paymentStatusInterval);
      this.paymentStatusInterval = void 0;
    }
  }
  async getPaymentStatus() {
    try {
      const response = await this.apiService.getCardPaymentStatus(
        this.startPaymentLoadable.payload.transactionReference
      );
      this.paymentRedirect = response.redirect;
      this.paymentStore.setPaymentStatus(response.status);
      if (this.cardManagerStore.cardManagerView && ["COMPLETED", "REJECTED", "ERROR"].includes(response.status)) {
        this.cardManagerStore.showCardSavingResultNotice(response.status);
        this.setReloadAdyenPaymentMethodInputs(true);
      }
      this.paymentStore.paymentHasFinalStatus && this.clearInterval();
    } catch (error) {
      this.clearInterval();
      if (error.status === ApiService.NOT_FOUND) {
        this.paymentStore.setPaymentStatus("NOT_FOUND");
      }
    }
  }
  setReloadAdyenPaymentMethodInputs(reload) {
    this.reloadAdyenPaymentMethodInputs = reload;
  }
  get paymentReady() {
    return !!(this.startPaymentLoadable && this.startPaymentLoadable.isFinished && !!this.startPaymentLoadable?.payload?.transactionReference);
  }
  getDropInEnvironment() {
    if (this.apiService.environment === "live") {
      return "live";
    }
    return "test";
  }
}
export {
  CardStore as default
};
